module.exports = __webpack_public_path__ + "img/ec.a608e632.svg";